import { render, staticRenderFns } from "./ThirdLevelSubGroup.vue?vue&type=template&id=5479d868&scoped=true&"
import script from "./ThirdLevelSubGroup.vue?vue&type=script&lang=js&"
export * from "./ThirdLevelSubGroup.vue?vue&type=script&lang=js&"
import style0 from "./ThirdLevelSubGroup.vue?vue&type=style&index=0&id=5479d868&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5479d868",
  null
  
)

export default component.exports